import { gql } from '@apollo/client';

export const DELETE_MEMBER_FROM_GROUP = gql`
	mutation deleteMemberFromGroup($input: CrewMemberGroupAssignmentInput!) {
		unAssignCrewMemberFromGroups(input: $input) {
			fullName
			id
		}
	}
`;
